// extracted by mini-css-extract-plugin
module.exports = {"headerHeight":"60","mediaWidthMobile":"320px","mediaWidthTablet":"1024px","mediaWidthDesktop":"1440px"};